import {
  DocumentSnapshot,
  SnapshotOptions,
  Timestamp,
} from 'firebase/firestore';
import { validateTimestamp } from './deck.model';

/** values determinded by https://www.npmjs.com/package/@flasd/spaced-repetition
 *  see also SpacedRepetitionService
 */
export enum Difficulty {
  HARD = 1,
  MEDIUM = 2,
  EASY = 3,
}
export type ReviewId = string;
export class Review {
  id: ReviewId;
  flashCardId?: string;
  difficulty?: Difficulty;
  timestamp?: Timestamp;

  constructor(
    id: ReviewId,
    flashCardId: string | undefined,
    difficulty: Difficulty | undefined,
    timestamp: Timestamp | undefined
  ) {
    this.id = id;
    this.flashCardId = flashCardId;
    this.difficulty = difficulty ?? Difficulty.HARD;
    this.timestamp = timestamp;
  }
}

export const reviewConverter = {
  toFirestore: (review: Review) => {
    return {
      flashCardId: review.flashCardId,
      difficulty: review.difficulty?.valueOf(),
      timestamp: validateTimestamp(review.timestamp) || Timestamp.now(),
    };
  },
  fromFirestore: (snapshot: DocumentSnapshot, options?: SnapshotOptions) => {
    if (!snapshot.exists()) {
      return undefined;
    }
    const data = snapshot.data(options);
    return new Review(
      snapshot.id,
      data['flashCardId'] ?? undefined,
      <number>data['difficulty'],
      data['timestamp'] ?? undefined
    );
  },
};
